export default __webpack_public_path__ + "static/media/Price Icon  1.a12db4d1.svg";